const MONTH_FORMATTERS: Record<'numeric' | '2-digit', Intl.DateTimeFormat> = {
  numeric: new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' }),
  '2-digit': new Intl.DateTimeFormat('en-US', { month: 'short', year: '2-digit', timeZone: 'UTC' }),
};

/**
 * A month key as e.g. "Jan 2025" (`year: 'numeric'`) or "Jan 25" (`year: '2-digit'`). Accepts
 * both `YYYY-MM` and `YYYY-MM-01`; both parse as ISO. UTC avoids a negative-offset zone
 * reading the previous month. Guards an unparseable month with an em-dash rather than throwing
 * a `RangeError`.
 */
export function formatMonth(month: string, year: 'numeric' | '2-digit'): string {
  const date = new Date(month);
  if (Number.isNaN(date.getTime())) return '—';
  return MONTH_FORMATTERS[year].format(date);
}

// One per language: a table builds a row header per month on every render.
const SPOKEN_MONTH_FORMATTERS = new Map<string, Intl.DateTimeFormat>();

/**
 * A month key as a screen reader should say it in the user's language, e.g. "February 2025" or
 * "fevereiro de 2025". `formatMonth` stays in English because the chart axes and the PDF use it.
 */
export function formatSpokenMonth(month: string, language: string): string {
  const date = new Date(month);
  if (Number.isNaN(date.getTime())) return month;
  let formatter = SPOKEN_MONTH_FORMATTERS.get(language);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(language, {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    });
    SPOKEN_MONTH_FORMATTERS.set(language, formatter);
  }
  return formatter.format(date);
}
